// extracted by mini-css-extract-plugin
module.exports = {"top":"_80ad21f8ef--top--1tXNa","title":"_80ad21f8ef--title--3Wgqb"};